import { t } from '@lingui/macro';

import Badge from '@decisiv/ui-components/lib/components/Badge';
import Flex from '@decisiv/ui-components/lib/components/Flex';
import { H4 } from '@decisiv/ui-components/lib/components/Typography';
import Network from '@decisiv/iconix/lib/components/Network';

export default function FleetManagementInfo() {
  return (
    <Flex alignItems="center" marginLeft={1}>
      <Badge
        icon={Network}
        color="information"
        palette="pastel"
        aria-label={t`Fleet Management`}
      />
      <H4 marginLeft={1}>{t`Fleet Management`}</H4>
    </Flex>
  );
}
